import { render, staticRenderFns } from "./ShiftAtomLaboratory.vue?vue&type=template&id=7b8f695a&scoped=true&"
import script from "./ShiftAtomLaboratory.vue?vue&type=script&lang=ts&"
export * from "./ShiftAtomLaboratory.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftAtomLaboratory.vue?vue&type=style&index=0&id=7b8f695a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8f695a",
  null
  
)

export default component.exports